import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import {useSelector} from "react-redux";

const CreateBusinessProfileBanner = () => {
    const isRootUser = useSelector(state =>  state?.user?.user?.is_root_user)
  return (
    <Box
      sx={{
        position: 'relative',
        backgroundColor: '#FFF4E5',
        border: '1px solid #FFD580',
        borderRadius: '12px',
        p: 3,
        mx: 'auto',
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
        mb: '2rem',
        mt: '-2rem'
      }}
    >
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <InfoIcon color="warning" sx={{ mr: 1 }} />
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#C47F00' }}>
          Important: Register Your Business Profile for Oman E-Invoicing
        </Typography>
      </Box>
      {/* Body */}
      <Typography variant="body1" sx={{ mb: 2, color: '#4A4A4A' }}>
        <strong>Note:</strong> Your profile is not yet registered to the Oman E-Invoicing Network. Because of this, you are currently unable to send or receive electronic documents for this profile.
          <br />
          {isRootUser ? "To get started and enable e-invoicing, please register your business by clicking the Register button on your screen.":"Please contact your admin to register the business."}
      </Typography>
      <Typography variant="body1" sx={{ color: '#4A4A4A' }}>
        <strong>Need Help?</strong> Do reach out to our team at&nbsp;
        <Link href="mailto:sr@marmin.ai" color="primary" underline="hover">
          sr@marmin.ai
        </Link>
        .
      </Typography>
    </Box>
  );
};

export default CreateBusinessProfileBanner;
